/*
 *     Import
 *     - Libraries
 */
import * as React from 'react'

import DatePicker from '../../../../common/DatePicker/DatePicker'
import { SearchSelect } from '../../../../common/SearchSelect/SearchSelect'
import onClickOutside from 'react-onclickoutside'
import { get } from 'lodash'
import { PlusIcon } from '../../../../../images/icons/Plus/Plus'
import { BinIcon } from '../../../../../images/icons/Bin/Bin'
var EnhancedSearchComponent = onClickOutside(SearchSelect)

interface Claim {
    id: number;
    date: string;
    amount: number;
    description: string;
    peril: string | null;
}

class ClaimFormCP extends React.Component<any, any> {

    constructor(props: { ClaimDetails: Claim[] }) {
        super(props)
        const { ClaimDetails = [] } = props
        this.state = {
            claimDetails: ClaimDetails.length > 0 ? ClaimDetails.map((claim: Claim) => ({
                id: claim.id || '',
                date: claim.date || '',
                amount: claim.amount || '',
                description: claim.description || '',
                peril: claim.peril || '',
            })) : [{ date: '', amount: '', description: '', peril: '' }],
            perilList: [
                { value: 'Accidental Damage', text: 'Accidental Damage' },
                { value: 'Earthquake', text: 'Earthquake' },
                { value: 'Escape of Oil', text: 'Escape of Oil' },
                { value: 'Escape of Water', text: 'Escape of Water' },
                { value: 'Explosion', text: 'Explosion' },
                { value: 'Fire', text: 'Fire' },
                { value: 'Flood', text: 'Flood' },
                { value: 'Impact', text: 'Impact' },
                { value: 'Liability', text: 'Liability' },
                { value: 'Malicious Damage', text: 'Malicious Damage' },
                { value: 'Storm', text: 'Storm' },
                { value: 'Subsidence', text: 'Subsidence' },
                { value: 'Terrorism', text: 'Terrorism' },
                { value: 'Theft', text: 'Theft' },
                { value: 'Other', text: 'Other' },
            ],
        }
    }

    componentDidUpdate(prevProps: any) {
        const {
            ClaimDetails = [],
        } = this.props
        if (JSON.stringify(ClaimDetails) !== JSON.stringify(prevProps.ClaimDetails)) {
            this.setState({
                claimDetails: ClaimDetails.length > 0 ?
                    ClaimDetails : [{ date: '', amount: '', description: '', peril: '' }],
            })
        }
    }

    handleDynamicChange = (index, value = '', field = '') => {

        const newClaimDetails = this.state.claimDetails.map((client, sidx) => {

            if (index !== sidx) { return client }

            switch (field) {
                case 'date': return { ...client, date: value }
                case 'amount': return { ...client, amount: value }
                case 'description': return { ...client, description: value }
                case 'peril': return { ...client, peril: value }
                default: return { ...client }
            }

        })

        this.setState({ claimDetails: newClaimDetails })
        this.props.setFieldValue(newClaimDetails, this.props.name)
    }

    handleDynamicValueChange = (index) => (event) => {
        this.handleDynamicChange(index, event.target.value, event.target.name)
    }

    handleAmountChange = (index) => (event) => {
        let val: any = Number(event.target.value.replace(/[^0-9]/g, ''))
        this.handleDynamicChange(index, val, event.target.name)
    }

    handleDynamicAdd = () => {
        this.setState({
            claimDetails: this.state.claimDetails.concat([{ date: '', amount: '', description: '', peril: '' }]),
        })
        this.props.setFieldValue(this.state.claimDetails, this.props.name)
    }

    handleDynamicRemove = (index) => () => {
        const updatedClaimDetails = this.state.claimDetails.filter((_, sidx) => sidx !== index)

        this.setState({
            claimDetails: updatedClaimDetails,
        })

        this.props.setFieldValue(updatedClaimDetails, this.props.name)
    }

    focusChange(event: any) {
        if (event.target.classList.contains('calendar__input')) {
            event.target.parentNode.parentNode.previousSibling.classList = 'active'
        } else {
            event.target.previousSibling.classList = 'active'
        }
    }

    calendarChange = (date: any, index: any) => {
        this.handleDynamicChange(index, date, 'date')
    }

    render() {
        const { perilList, claimDetails } = this.state
        return (
            <div className={`quote__form__inner${this.props.extraClass} ${(this.props.show) ? 'active' : ''}`}>

                <div className="quote__form__dynamicGroup">
                    {claimDetails.map((claimDetail, index) => (
                        <div key={index} className="quote__form__dynamic">

                            <div className="quote__form__group quote__form__group--calendar form__w50">
                                <label>Claim date</label>
                                <DatePicker
                                    placeholder={claimDetail.date ? claimDetail.date : 'Claim date'}
                                    index={index}
                                    onChange={this.calendarChange}
                                    onFocus={this.focusChange}
                                    claim={true}
                                    dateSelected={claimDetail.date}
                                    placeholderIsDate={claimDetail.date ? true : false}
                                />
                            </div>

                            <div className="quote__form__group form__w50 quote__form__group--claimAmount">
                                <label>Amount</label>
                                <input
                                    name="amount"
                                    className=""
                                    id="amount"
                                    type="text"
                                    min="0"
                                    placeholder="Amount"
                                    onChange={this.handleAmountChange(index)}
                                    onFocus={this.focusChange}
                                    value={Number(get(claimDetail, 'amount', 0)).toLocaleString('en-GB')}
                                />
                            </div>
                            <div className="quote__form__group quote__form__group--calendar form__w50 claim_peril">
                                <EnhancedSearchComponent
                                    itemList={perilList}
                                    name="peril"
                                    setFieldValue={(name, val) => { this.handleDynamicChange(index, val, name) }}
                                    selected={[
                                        claimDetail.peril,
                                        claimDetail.peril,
                                    ]}
                                    label="Peril"
                                    searchPlaceholder={'search peril'}
                                />
                            </div>
                            <div className={`quote__form__group form__w50 claim-desc`}>
                                <label>Description</label>
                                <input
                                    name="description"
                                    id="description"
                                    type="text"
                                    placeholder="Description"
                                    onChange={this.handleDynamicValueChange(index)}
                                    onFocus={this.focusChange}
                                    value={claimDetail.description}
                                />
                            </div>

                            <button
                                type="button"
                                onClick={this.handleDynamicRemove(index)}
                                className="quote__form__dynamic--remove"
                                style={{ right: '0' }}
                            >
                                <BinIcon />
                            </button>
                        </div>
                    ))}
                </div>

                <button
                    type="button"
                    onClick={this.handleDynamicAdd}
                    className="quote__form__dynamic--add"
                >
                    <PlusIcon /><span>Add another claim</span><PlusIcon />
                </button>
            </div>
        )
    }
}

export default ClaimFormCP



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step01/components/ClaimFormCP.tsx